(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["veil-guide-launcher"]) return;
  try {
    
(() => {
  const config = document.querySelector('.vv-guide-launcher-config');
  const label = config?.dataset.label || 'Veil Guide';
  const contactUrl = config?.dataset.contactUrl || '/pages/contact';

  const connectContactButtons = () => {
    const contactLabels = /^(contact|contact us|contact support|contact violet)$/i;

    document.querySelectorAll('a, button').forEach((element) => {
      const text = element.textContent.trim().replace(/\s+/g, ' ');
      if (!contactLabels.test(text)) return;

      if (element.tagName === 'A') {
        element.setAttribute('href', contactUrl);
        return;
      }

      if (element.dataset.vvContactButton === 'true') return;
      element.dataset.vvContactButton = 'true';
      element.addEventListener('click', () => window.location.assign(contactUrl));
    });
  };

  const customiseLauncher = () => {
    const host = document.querySelector('shopify-chat');
    const root = host?.shadowRoot;
    if (!root) return false;

    const button = root.querySelector('[part="activator"]');
    const buttonLabel = root.querySelector('.activator__label');
    if (button) button.setAttribute('aria-label', label);
    if (buttonLabel && buttonLabel.textContent !== label) buttonLabel.textContent = label;

    if (!root.querySelector('#vv-guide-launcher-style')) {
      const style = document.createElement('style');
      style.id = 'vv-guide-launcher-style';
      style.textContent = `
        .activator__label {
          color: #ffffff !important;
          -webkit-text-fill-color: #ffffff !important;
          font-family: "Segoe Script", "Brush Script MT", "Apple Chancery", cursive !important;
          font-size: 20px !important;
          font-weight: 600 !important;
        }
        .activator__icon,
        .activator__icon svg,
        .activator__icon path {
          color: #ffffff !important;
          stroke: #ffffff !important;
        }
        .activator__indicator {
          display: none !important;
        }
      `;
      root.appendChild(style);
    }

    return true;
  };

  if (!customiseLauncher()) {
    const observer = new MutationObserver(() => {
      if (customiseLauncher()) observer.disconnect();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  connectContactButtons();

  const contactObserver = new MutationObserver(connectContactButtons);
  contactObserver.observe(document.body, { childList: true, subtree: true });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vv-horoscope-fresh"] && !Shopify.designMode) return;
  try {
    
(function(){
"use strict";
const escapeHTML=value=>String(value).replace(/[&<>"']/g,c=>({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"}[c]));
function paragraphs(value){return String(value).split(/\n\n+/).map(part=>`<p>${escapeHTML(part)}</p>`).join("");}
function londonKey(date){return new Intl.DateTimeFormat("en-CA",{timeZone:"Europe/London",year:"numeric",month:"2-digit",day:"2-digit"}).format(date);}
function dayNumber(key){return Math.floor(Date.parse(key+"T12:00:00Z")/86400000);}
function choose(items,day,step,offset){return items[((day*step+offset)%items.length+items.length)%items.length];}
function selectReading(data,sign,key){
const index=data.signs.findIndex(s=>s.id===sign.id),bank=data.bank[sign.id],day=dayNumber(key),offset=index*17;
return {story:choose(bank.stories,day,5,offset),love:choose(bank.love,day,3,offset+2),work:choose(bank.work,day,2,offset+3),life:choose(bank.life,day,1,offset+1),oracle:choose(data.oracles,day,5,index*7)};
}
function init(root){
if(root.dataset.ready==="true")return;
const source=root.querySelector("[data-vv-hscope-data]");
if(!source)return;
const data=JSON.parse(source.textContent,(key,value)=>typeof value==="string"?value.replace(/&(?:amp|lt|gt|quot|#39);/g,entity=>({"&amp;":"&","&lt;":"<","&gt;":">","&quot;":'"',"&#39;":"'"}[entity])):value),L=data.labels,view=root.querySelector("[data-vv-hscope-view]"),uid=root.id;
let stored=null;try{stored=localStorage.getItem("daily-horoscope-sign");}catch(e){}
let sign=data.signs.find(s=>s.id===stored)||data.signs.find(s=>s.id===root.dataset.defaultSign)||data.signs[0];
let key=londonKey(new Date());
root.dataset.ready="true";
function render(){
const r=selectReading(data,sign,key);
const dateText=new Intl.DateTimeFormat("en-GB",{timeZone:"Europe/London",weekday:"long",day:"numeric",month:"long"}).format(new Date(key+"T12:00:00Z"));
view.innerHTML=`
<div class="vv-hscope__surface">
<div class="vv-hscope__chooser"><h3>${escapeHTML(L.choose)}</h3><p>${escapeHTML(L.intro)}</p>
<div class="vv-hscope__signs" role="group" aria-label="${escapeHTML(L.choose)}">${data.signs.map(s=>`<button class="vv-hscope__sign" type="button" data-sign="${s.id}" aria-pressed="${s.id===sign.id}" aria-label="${escapeHTML(s.name+' · '+s.dates)}"><img src="${escapeHTML(s.image)}" alt="" width="55" height="55" loading="lazy"><span>${escapeHTML(s.name)}</span></button>`).join("")}</div></div>
<div class="vv-hscope__reading" data-reading>
<div class="vv-hscope__topline"><div class="vv-hscope__brand">${escapeHTML(L.brand)}<small>${escapeHTML(L.home)}</small></div><div class="vv-hscope__date"><time datetime="${key}">${escapeHTML(dateText)}</time><small>${escapeHTML(L.updated)}</small></div></div>
<div class="vv-hscope__identity"><span class="vv-hscope__glyph" aria-hidden="true">${sign.glyph}</span><div><h2>${escapeHTML(sign.name)}</h2><p>${escapeHTML(sign.dates)}</p></div></div>
<section class="vv-hscope__panel" id="${uid}-panel" aria-labelledby="${uid}-daily-title"><p class="vv-hscope__eyebrow">${escapeHTML(sign.name+' · '+L.today)}</p><h3 id="${uid}-daily-title">${escapeHTML(r.story[0])}</h3><div class="vv-hscope__prose">${paragraphs(r.story[1])}</div></section>
<div class="vv-hscope__glance">${["love","work","life"].map(t=>`<article><h3>${escapeHTML(L[t])}</h3>${paragraphs(r[t])}</article>`).join("")}</div>
<aside class="vv-hscope__action"><p class="vv-hscope__eyebrow">${escapeHTML(L.action)}</p><p>${escapeHTML(r.story[2])}</p></aside>
<details class="vv-hscope__oracle"><summary>${escapeHTML(L.reveal)}</summary><div class="vv-hscope__oracle-body"><img src="https://cdn.shopify.com/s/files/1/1000/7966/5490/files/veil-violet-daily-oracle-card.png?v=1789342085" alt="" width="90" height="175" loading="lazy"><div><h3>${escapeHTML(r.oracle.name)}</h3><p>${escapeHTML(r.oracle.message)}</p><p><strong>${escapeHTML(L.meaning)}:</strong> ${escapeHTML(r.oracle.meaning)}</p><p><strong>${escapeHTML(L.ritual)}:</strong> ${escapeHTML(r.oracle.ritual)}</p></div></div></details>
<p class="vv-hscope__note">${escapeHTML(L.note)}</p>
</div></div>`;
}
root.addEventListener("click",event=>{
const button=event.target.closest("button");if(!button||!root.contains(button))return;
if(button.dataset.sign){
const next=data.signs.find(s=>s.id===button.dataset.sign);if(!next)return;sign=next;
try{localStorage.setItem("daily-horoscope-sign",sign.id);}catch(e){}
render();view.querySelector('[data-sign="'+sign.id+'"]').focus({preventScroll:true});
view.querySelector("[data-reading]").scrollIntoView({behavior:window.matchMedia("(prefers-reduced-motion: reduce)").matches?"auto":"smooth",block:"start"});
}
});
render();
const timer=window.setInterval(()=>{if(!root.isConnected){window.clearInterval(timer);return;}const next=londonKey(new Date());if(next!==key){key=next;render();}},60000);
}
function boot(scope){scope.querySelectorAll("[data-vv-hscope]").forEach(init);}
if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",()=>boot(document));else boot(document);
document.addEventListener("shopify:section:load",event=>boot(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
